export default __webpack_public_path__ + "static/media/CFTC.fc5b0edc.svg";